<template>
  <div class="denomination-select">
    <template v-for="item in items">
      <div
        class="denomination-select-item"
        v-if="!item.disabled"
        :class="{
          disabled: disabled,
          active: activeId === item[keyFields.id],
        }"
        :key="item[keyFields.id]"
        @click="clickHandler(item)"
      >
        <div class="show-price">{{ item[keyFields.value] }}</div>
        <div
          class="sale-price"
          v-if="showSalePrice"
        >
          售价{{ item[keyFields.salePrice] }}元
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'DenominationSelect',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    keyFields: {
      type: Object,
      default: () => ({
        id: 'id',
        value: 'value',
        salePrice: 'salePrice'
      })
    },
    showSalePrice: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    keepSelected: {
      type: Boolean,
      default: false
    },
    productSkuCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      activeId: ''
    };
  },
  watch: {
    productSkuCode: {
      immediate: true,
      handler(val) {
        val && this.init();
      }
    }
  },
  methods: {
    init() {
      if (this.$route.query.source === 'wxapp' || this.$route.query.companyNo === 'XDCX' && this.$route.query.erId) {
        this.$nextTick(() => {
          this.activeId = this.productSkuCode;
        });
      }
    },
    clickHandler(price) {
      if (this.$route.query.companyNo === 'XDCX' && this.$route.query.erId) {
        return;
      }
      if (this.disabled || price.disabled) {
        return;
      }
      if (this.keepSelected) {
        this.activeId = price[this.keyFields.id];
      }
      this.$emit('getPrice', price);
    },
    reset() {
      this.setActiveId('');
    },
    setActiveId(id) {
      this.activeId = id;
    }
  },
  created() {},
  mounted() {
  }
};
</script>

<style lang="scss" scoped>
.denomination-select {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.2rem;
  background-color: white;
  padding: 0.4rem;

  &-item {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 2.1rem;
    height: 1.2rem;
    color: #383838;
    letter-spacing: 0.63px;
    font-weight: 600;
    text-align: center;
    border-radius: 0.16rem;
    border: 0.02rem solid #e6e6e6;

    > .show-price {
      font-size: 0.42rem;
      font-weight: 500;
    }

    > .sale-price {
      color: #c8c8c8;
      font-size: 0.24rem;
      font-weight: 400;
      margin-top: 0.1rem;
    }

    &.disabled {
      opacity: 0.5;

      &:active {
        border-color: #e6e6e6;
        background-color: transparent;
        color: #383838;
      }
    }

    &:active {
      border-color: #3399ff;
      background-color: #cce6ff;
      color: #3399ff;
    }

    &.active {
      border-color: #3399ff;
      background-color: #cce6ff;
      color: #3399ff;
      > .sale-price {
        color: #3399ff;
      }
    }
  }
}
</style>
